export default __webpack_public_path__ + "static/media/biology-card-bg.e3f98ec3.svg";